<template>
    <div class="container bg-white q-pa-xs">
        <q-input
            class="q-ma-xs"
            dense
            debounce="200"
            outlined
            clearable
            :value="keyword" 
            @input="onChange"
            @keyup.enter="onEnter"
            @clear="onClear"
            label="Search"
            placeholder="Search product (example: water, apple, turkey)"
        />
    </div>
</template>

<style scoped>
.container {
    height: 60px;
}
</style>

<script>
import { mapState } from 'vuex';
export default {
    name: "SearchBar",
    data() {
        return {
        };
    },
    computed: {
        ...mapState({
            keyword: (state) => state.search.keyword,
        }),
    },
    methods: {
        onChange(keyword){
            this.$store.commit("search/setKeyword", keyword);
            this.$store.dispatch("search/autoComplete", keyword);
            this.$store.commit("search/setShowAutoCompleteResult", true);
        },
        onEnter(){
            this.$store.dispatch("search/search", this.keyword);
            this.$store.commit("search/setShowAutoCompleteResult", false);
            this.$store.commit("search/setShowSearchResult", true);
        },
        onClear(){
            this.$store.commit("search/setKeyword", "");
            this.$store.commit("search/setShowAutoCompleteResult", false);
            this.$store.commit("search/setShowSearchResult", false);
        }
    }
};
</script>
